import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Routes from 'Routes';
import { EventDatetimeContext } from 'components/EventDatetime';
import isChatroomDisabled from 'components/chat/utils/isChatroomDisabled';
import useCurrentAttendee from './useCurrentAttendee';

const disabledPaths = [
  Routes.landing,
];

const useChatVisibility = () => {
  const { uuid } = useCurrentAttendee();
  const { pathname } = useLocation();
  const { chatroomConfig, features } = useSelector((state) => state.eventConfigs);
  const { hasEventStarted } = useContext(EventDatetimeContext);

  return useMemo(() => (
    !disabledPaths.some((disabledPath) => pathname.startsWith(disabledPath))
    && (features.includes('internalQA') || hasEventStarted)
    && uuid
    && !isChatroomDisabled(chatroomConfig)
  ), [pathname, features, uuid, chatroomConfig, hasEventStarted]);
};

export default useChatVisibility;
